import CachedIcon from "@mui/icons-material/Cached";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Tab,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Tabs,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
} from "@mui/material";

import FlagIcon from "@mui/icons-material/Flag";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_TableInstance,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "react-multi-date-picker/styles/colors/green.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState, useAppDispatch } from "../../../app/features/store/store";
import {
  CLIENT_INVOICE_COLUMN_NAME,
  CLIENT_INVOICE_LABEL_NAME,
  CLIENT_INVOICE_STATUS,
} from "./ClientInvoiceConstants";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import {
  getFdpListByClient,
  setSelectedFDP,
} from "../../../app/features/fdp/fdpSlice";
import { getDefaultMRTOptions } from "../../dedicatedDelivery/DefaultMrtOptions";
import { CustomTooltip } from "../../../components/common/tooltip/CustomToolTip";
import { updateUserTokenToInvalid } from "../../../app/features/login/loginSlice";
import getAxiosError from "../../../app/api/axiosError";
import { RatecardClientInvoiceResponse } from "../../../app/models/responseModels/ClientInvoiceResponses";
import { SubmittedClientInvoice } from "../../../app/models/responseModels/ClientInvoiceResponses";
import { ClientInvoiceAgent } from "../../../app/api/clientInvoices/ClientInvoiceAgent";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ManualGenerateClientInvoiceModal from "./ManualGenerateClientInvoiceModal";
import ManualUploadSubmittedInvoiceModal from "./ManualUploadSubmittedInvoiceModal";
import { useSubmitModal } from "../../../components/common/modalPopup/useSubmitModal";
import { ClientInvoiceListUIResponse, SubmittedClientInvoiceListUIResponse } from "../../../app/models/ApiResponse";
import InvoicePreviewModal from "./modals/InvoicePreviewModal";
import SubmittedInvoicePreviewModal from "./modals/SubmittedInvoicePreviewModal";
import { getInvoiceStatusCellColour } from "./utils/ClientInvoiceUtils";
import InvoiceEditModal from "./modals/InvoiceEditModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SubmitInvoiceModal from "./modals/SubmitInvoiceModal";
import InvoiceApprovalModal from "./modals/InvoiceApprovalModal";
import { StoreFdpsResponse } from "../../../app/models/responseModels/FdpResponse";
import { FdpInvoiceListUIResponse } from "../../../app/models/ApiResponse";
import { FdpInvoiceAgent } from "../../../app/api/fdpInvoices/FdpInvoiceAgent";
import {
  ClientData,
  InvoiceStatus,
  RatecardFdpInvoiceResponse,
} from "../../../app/models/responseModels/FdpInvoiceResponses";
import FdpInvoicePreviewModal from "../../fdp/invoices/modals/FdpInvoicePreviewModal";

import { styled } from "@mui/material/styles";
import FdpInvoiceEditModal from "../../fdp/invoices/modals/FdpInvoiceEditModal";
import { BorderColor, Delete, ExpandCircleDown } from "@mui/icons-material";
import { error, log } from "console";
import Error from "../../error/Error";
import ConfirmModal from "../../../components/common/modalPopup/ConfirmModal";
import {
  formatFromAndToDateString,
  formatISODateString,
} from "../../../components/common/utils/DateUtils";

export type ClientInvoiceListProps = {
  clientId: number;
  clientName: string;
  clientType: string;
  startDate: Date;
  endDate: Date;
};

export type SoftDeleteInvoiceProps = {
  clientInvoiceIds: string[];
  source: string;
};

const ClientInvoiceList = (props: ClientInvoiceListProps) => {
  // access all parameters passed
  const clientId = props.clientId;
  const clientName = props.clientName;

  const dispatch = useAppDispatch();

  // import base configruation for grid
  const defaultMRTOptions =
    getDefaultMRTOptions<RatecardClientInvoiceResponse>();
  const defaultMRTOptionsSubmitted =
    getDefaultMRTOptions<SubmittedClientInvoice>();

  // state to manage pagination values from grid
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  // state to manage pagination for submitted invoices
  const [submittedPagination, setSubmittedPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [tabValue, setValue] = useState(0);
  //const [selectedFDP, setSelectedFDP] = useState<string | null>(null);

  const [showInvoiceEditModal, setShowInvoiceEditModal] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentInvoice, setCurrentInvoice] = useState<
    RatecardClientInvoiceResponse | undefined
  >(undefined);
  const [clientInvoiceListData, setClientInvoiceListData] =
    useState<ClientInvoiceListUIResponse>();

  const [submittedInvoiceListData, setSubmittedInvoiceListData] =
    useState<SubmittedClientInvoiceListUIResponse>();

  const [fdpInvoiceListData, setFdpInvoiceListData] =
    useState<FdpInvoiceListUIResponse>();

  const [clientData, setClientData] = useState<ClientData[]>([]);

  const { authResponse } = useSelector((state: RootState) => state.login);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    clientInvoiceIds: [] as string[],
    source: "",
  });

  const [showSubmittedConfirmDelete, setShowSubmittedConfirmDelete] = useState(false);
  const [submittedRowSelection, setSubmittedRowSelection] = useState<MRT_RowSelectionState>({});
  const [submittedInvoicesToDelete, setSubmittedInvoicesToDelete] = useState<{ id: number; clientInvoiceId: string }[]>([]);

  const [isFdpInvoice, setIsFdpInvoice] = useState(false);
  const [isFdcInvoice, setIsFdcInvoice] = useState(false);
  const [currentSubmittedInvoice, setCurrentSubmittedInvoice] = useState<SubmittedClientInvoice | undefined>(undefined);

  const [submittedInvoicePreviewModal, openSubmittedInvoicePreviewModal] = useSubmitModal(
    (closeSubmittedInvoicePreviewModal) => (
      <SubmittedInvoicePreviewModal
        invoice={currentSubmittedInvoice}
        closeInvoicePreviewModal={closeSubmittedInvoicePreviewModal}
      />
    )
  );

  // ***** Callbacks *****
  const getClientInvoiceListData = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await ClientInvoiceAgent.getClientInvoiceList(clientId, {
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
      if (!response.isSuccess) {
        toast.error(response.message!, {
          toastId: "clientInvoiceList",
        });
      } else {
        setClientInvoiceListData(response);
        setIsFdcInvoice(false);
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "clientInvoiceListException",
      });
    } finally {
      setIsLoading(false);
    }
  }, [clientId, pagination.pageIndex, pagination.pageSize, isFdcInvoice]);



  const getSubmittedInvoiceListData = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await ClientInvoiceAgent.getClientSubmittedInvoiceList(clientId, {
        pageIndex: submittedPagination.pageIndex,
        pageSize: submittedPagination.pageSize,
      });
      if (!response.isSuccess) {
        toast.error(response.message!, {
          toastId: "submittedInvoiceList",
        });
      } else {
        setSubmittedInvoiceListData(response);
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "submittedInvoiceListException",
      });
    } finally {
      setIsLoading(false);
    }
  }, [clientId, submittedPagination.pageIndex, submittedPagination.pageSize]);

  const fetchClientInvoiceFile = async (
    clientInvoiceId: number,
    invoiceStatus: string
  ) => {
    try {
      setIsLoading(true);
      const response = await ClientInvoiceAgent.fetchDownloadClientInvoiceFile(
        clientInvoiceId,
        invoiceStatus
      );
      if (response.status !== 200) {
        toast.error("Document couldn't retrived.", {
          toastId: "FetchClientInvoiceFileError",
        });
      }
      const fileName = response.headers["file-name"];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error("File isn't accessible.", {
        toastId: "FetchClientInvoiceFileException",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientSubmittedInvoiceFile = async (
    clientInvoiceId: number,
    invoiceStatus: string
  ) => {
    try {
      setIsLoading(true);
      const response = await ClientInvoiceAgent.fetchDownloadMAnualUploadedClientInvoiceFile(
        clientInvoiceId
      );
      if (response.status !== 200) {
        toast.error("Document couldn't retrived.", {
          toastId: "FetchClientInvoiceFileError",
        });
      }
      const fileName = response.headers["file-name"];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error("File isn't accessible.", {
        toastId: "FetchClientInvoiceFileException",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Method to soft delete
  const handleConfirmSoftDelete = (
    clientInvoiceIds: string[],
    source: string
  ) => {
    setInvoiceData({ clientInvoiceIds, source });
    setShowConfirmDelete(true);
  };

  const handleSubmittedInvoiceSoftDelete = async () => {
    setIsLoading(true);
    setShowSubmittedConfirmDelete(false);
    try {
      await ClientInvoiceAgent.softDeleteSubmittedInvoices(submittedInvoicesToDelete);
      setSubmittedInvoicesToDelete([]);
      setSubmittedRowSelection({});
      getSubmittedInvoiceListData();
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, { toastId: "submittedInvoiceSoftDeleteException" });
    } finally {
      setIsLoading(false);
    }
    return true;
  };

  const handleInvoiceSoftDelete = async () => {
    setIsLoading(true);
    setShowConfirmDelete(false);
    try {
      const { clientInvoiceIds, source } = invoiceData;

      const response = await ClientInvoiceAgent.softDeleteInvoices(
        clientInvoiceIds,
        source
      );

      if (source === "fdc") {
        //await new Promise(resolve => setTimeout(resolve, 1000));
        setIsFdcInvoice(true);
        //setRowSelection({});
      }

      setShowConfirmDelete(false);
      setInvoiceData({ clientInvoiceIds: [], source: "" });
    } catch (error) {
      const appError = getAxiosError(error);
      console.error("Error during invoice soft delete:", appError);
      toast.error(appError.errorMessage, {
        toastId: "invoiceSoftDeleteException",
      });
    } finally {
      setIsLoading(false);
    }
    return true;
  };

  // const getFdpInvoiceListData = useCallback(async () => {
  //   try {
  //     const response = await FdpInvoiceAgent.getFdpInvoiceList(selectedFDP, {
  //       pageIndex: pagination.pageIndex,
  //       pageSize: pagination.pageSize,
  //     });
  //     if (!response.isSuccess) {
  //       toast.error(response.message!, {
  //         toastId: "fdpInvoiceList",
  //       });
  //     } else {
  //       setFdpInvoiceListData(response);
  //       let duplicateClientData: ClientData[] = [];
  //       response.data.content.forEach((fdpInvoice) => {
  //         let clientsData: ClientData[] = fdpInvoice.stores.map((store) => {
  //           let client: ClientData = {
  //             clientId: store.clientId,
  //             clientName: store.clientName,
  //           };
  //           return client;
  //         });

  //         duplicateClientData = duplicateClientData.concat(clientsData);
  //       });

  //       let clientIdList: number[] = [];
  //       let uniqueClientData: ClientData[] = [];

  //       duplicateClientData.forEach((value) => {
  //         if (!clientIdList.includes(value.clientId)) {
  //           clientIdList.push(value.clientId);
  //           uniqueClientData.push(value);
  //         }
  //       });

  //       setClientData(uniqueClientData);
  //     }
  //   } catch (error) {
  //     const appError = getAxiosError(error);
  //     toast.error(appError.errorMessage, {
  //       toastId: "fdpInvoiceListException",
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }, [dispatch, pagination]);

  // set page title
  useEffect(() => {
    document.title = "Clients - Invoices";
  }, []);

  // ***** UseEffects *****
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getClientInvoiceListData();
    }

    return () => {
      isMounted = false;
    };
  }, [getClientInvoiceListData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted && tabValue === 2) {
      getSubmittedInvoiceListData();
    }

    return () => {
      isMounted = false;
    };
  }, [getSubmittedInvoiceListData, tabValue]);

  // useEffect(() => {
  //   if (isFdcInvoice) {
  //     getClientInvoiceListData();
  //     setIsFdcInvoice(false);
  //   }
  // }, [isFdcInvoice, getClientInvoiceListData]);

  // map columns to show on grid
  const columns = useMemo<MRT_ColumnDef<RatecardClientInvoiceResponse>[]>(
    () => [
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.SL_NO,
        header: CLIENT_INVOICE_LABEL_NAME.SL_NO,
        size: 50,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.INVOICE_ID,
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_ID,
        size: 100,
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.NET_PAYMENT,
        header: CLIENT_INVOICE_LABEL_NAME.NET_PAYMENT,
        size: 50
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.INVOICE_STATUS,
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_STATUS,
        size: 100,
        Cell: ({ row }) => {
          const theme = useTheme();
          // Get background color based on the invoice status
          const bgColor = getInvoiceStatusCellColour(
            row.original.invoiceStatus,
            theme
          );
          return (
            <Box
              sx={{
                color: bgColor !== "white" ? "white" : "black",
                backgroundColor: bgColor,
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              {row.original.currentStatus.externalStatus}(
              {row.original.currentStatus.internalStatus})
            </Box>
          );
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.ASSOCIATED_STORES,
        header: CLIENT_INVOICE_LABEL_NAME.ASSOCIATED_STORES,
        size: 100,
        Cell: ({ row }) => {
          return row.original.stores.map((store) => store.storeId).join(", ");
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.INVOICE_START_DATE,
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_START_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.INVOICE_END_DATE,
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_END_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.INVOICE_GENERATION_DATE,
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_GENERATION_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.AUTO_GENERATED,
        header: CLIENT_INVOICE_LABEL_NAME.AUTO_GENERATED,
        size: 100,
        Cell: ({ row }) => (row.original.isAutoGenerated ? "YES" : "NO"),
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.ASSOCIATED_FDPS,
        header: CLIENT_INVOICE_LABEL_NAME.ASSOCIATED_FDPS,
        size: 100,
        Cell: ({ row }) => {
          return (
            <Box>
              {row?.original?.fdpCompanyNames.map(
                (companyName: string, index: number) => (
                  <React.Fragment key={index}>
                    <span>{companyName}</span>
                    {index < row?.original?.fdpCompanyNames.length - 1 && (
                      <span style={{ margin: "0 8px" }}>,</span> // Separator
                    )}
                  </React.Fragment>
                )
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.CREATED_ON,
        header: CLIENT_INVOICE_LABEL_NAME.CREATED_ON,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },

      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.UPDATED_ON,
        header: CLIENT_INVOICE_LABEL_NAME.UPDATED_ON,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: CLIENT_INVOICE_COLUMN_NAME.SUBMIT_DATE,
        header: CLIENT_INVOICE_LABEL_NAME.SUBMIT_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
    ],
    []
  );

  // elements to be rendered on top of grid
  const renderTopToolbarCustomActions = (
    table: MRT_TableInstance<RatecardClientInvoiceResponse>
  ) => {
    const selectedRows = table.getSelectedRowModel().rows;
    const selectedInvoiceIds = selectedRows.map(
      (row) => row.original.clientInvoiceId
    );

    return (
      <Box>
        <CustomTooltip arrow title="Refresh" onClick={getClientInvoiceListData}>
          <IconButton type="button">
            <CachedIcon sx={{ color: "primary.main" }} />
          </IconButton>
        </CustomTooltip>

        <Button
          sx={{ m: 2 }}
          component="label"
          variant="contained"
          onClick={openManualGenerateInvoiceModal}
        >
          Create Manual Invoice
        </Button>
        <Button
          sx={{ color: "primary.main" }}
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleConfirmSoftDelete(selectedInvoiceIds, "fdc");
          }}
          disabled={selectedInvoiceIds.length === 0}
        >
          <Delete />
        </Button>
      </Box>
    );
  };

  // open invoice preview modal logic
  const [invoicePreviewModal, openInvoicePreviewModal] = useSubmitModal(
    (closeInvoicePreviewModal) => (
      <InvoicePreviewModal
        invoice={currentInvoice}
        closeInvoicePreviewModal={() => {
          closeInvoicePreviewModal();
          getClientInvoiceListData();
        }}
        showInvoiceEditModal={() => {
          closeInvoicePreviewModal();

          setShowInvoiceEditModal(true);
        }}
      />
    )
  );

  // open edit invoice modal logic
  const [submitInvoiceModal, openSubmitInvoiceModal] = useSubmitModal(
    (closeSubmitInvoiceModal) => (
      <SubmitInvoiceModal
        invoice={currentInvoice}
        closeSubmitInvoiceModal={() => {
          closeSubmitInvoiceModal();
          // refresh client invoice list after edit
          setIsLoading(true);
          getClientInvoiceListData();
        }}
      />
    )
  );
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  // Helper: safely parse a JSON array string or comma-separated string from backend
  const parseJsonArrayField = (val: string): string => {
    if (!val) return "N/A";
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed.join(", ") : val;
    } catch {
      return val;
    }
  };

  // store grid configuration for submitted invoices
  const submittedColumns = useMemo<MRT_ColumnDef<SubmittedClientInvoice>[]>(
    () => [
      {
        accessorKey: "clientInvoiceId",
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_ID,
        size: 100,
      },
      {
        accessorKey: "status",
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_STATUS,
        size: 100,
        Cell: ({ cell }) => {
          const theme = useTheme();
          const value = cell.getValue<string>();
          const bgColor = getInvoiceStatusCellColour(value, theme);
          return (
            <Box
              sx={{
                textAlign: "center",
                minWidth: "80px",
                color: "#191717",
                backgroundColor: theme.palette.grey[200],
                padding: "6px 12px",
                borderRadius: "8px",
              }}
            >
              {value}
            </Box>
          );
        },
      },
      {
        accessorKey: "netPayment",
        header: CLIENT_INVOICE_LABEL_NAME.NET_PAYMENT,
        size: 100,
      },
      {
        accessorKey: "associatedStores",
        header: CLIENT_INVOICE_LABEL_NAME.ASSOCIATED_STORES,
        size: 100,
        Cell: ({ cell }) => parseJsonArrayField(cell.getValue<string>()),
      },
      {
        accessorKey: "associatedFdps",
        header: CLIENT_INVOICE_LABEL_NAME.ASSOCIATED_FDPS,
        size: 100,
        Cell: ({ cell }) => parseJsonArrayField(cell.getValue<string>()),
      },
      {
        accessorKey: "startDate",
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_START_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          return value ? formatISODateString(value) : "N/A";
        },
      },
      {
        accessorKey: "endDate",
        header: CLIENT_INVOICE_LABEL_NAME.INVOICE_END_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          return value ? formatISODateString(value) : "N/A";
        },
      },
      {
        accessorKey: "submitDate",
        header: CLIENT_INVOICE_LABEL_NAME.SUBMIT_DATE,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          return value ? formatISODateString(value) : "N/A";
        },
      },
      {
        accessorKey: "createdOn",
        header: CLIENT_INVOICE_LABEL_NAME.CREATED_ON,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          return value ? formatISODateString(value) : "N/A";
        },
      },
      {
        accessorKey: "updatedOn",
        header: CLIENT_INVOICE_LABEL_NAME.UPDATED_ON,
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          return value ? formatISODateString(value) : "N/A";
        },
      },
      {
        accessorKey: "manualUpload",
        header: "Manual Upload",
        size: 100,
        Cell: ({ cell }) => (cell.getValue<boolean>() ? "Yes" : "No"),
      },
    ],
    []
  );

  const submittedTable = useMaterialReactTable<SubmittedClientInvoice>({
    ...defaultMRTOptionsSubmitted,
    enableRowSelection: true,
    enableRowActions: true,
    columns: submittedColumns,
    data: submittedInvoiceListData?.data.content ?? [],
    manualPagination: true,
    onPaginationChange: setSubmittedPagination,
    rowCount: submittedInvoiceListData?.data.totalElements ?? 0,
    initialState: {
      ...defaultMRTOptionsSubmitted.initialState,
      columnVisibility: {},
      sorting: [
        {
          id: "submitDate",
          desc: true,
        },
      ],
    },
    state: {
      pagination: submittedPagination,
      showProgressBars: isLoading,
      rowSelection: submittedRowSelection,
      columnOrder: [
        "mrt-row-select",
        "mrt-row-actions",
        ...submittedColumns.map((col) => col.accessorKey!),
      ],
    },
    onRowSelectionChange: setSubmittedRowSelection,
    getRowId: (row) => `${row.id}`,
    renderRowActions: ({ row }) => (
      <Box>
        <IconButton
          title="View"
          color="info"
          onClick={() => {
            setCurrentSubmittedInvoice(row.original);
            openSubmittedInvoicePreviewModal();
          }}
          disabled={row.original.status === "Client Manually Invoiced"}
        >
          <VisibilityIcon />
        </IconButton>
        <IconButton
          title="Download"
          color="primary"
          onClick={() => fetchClientSubmittedInvoiceFile(row.original.id, row.original.status)}
        >
          <CloudDownloadIcon />
        </IconButton>
      </Box>
    ),
    muiTableBodyRowProps: () => ({
      ...defaultMRTOptionsSubmitted.muiTableBodyRowProps,
    }),
    renderTopToolbarCustomActions: (({ table }: { table: MRT_TableInstance<SubmittedClientInvoice> }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const selectedInvoices = selectedRows.map((row: { original: SubmittedClientInvoice }) => ({
        id: row.original.id,
        clientInvoiceId: row.original.clientInvoiceId,
      }));
      return (
        <Box>
          <CustomTooltip arrow title="Refresh" onClick={getSubmittedInvoiceListData}>
            <IconButton type="button">
              <CachedIcon sx={{ color: "primary.main" }} />
            </IconButton>
          </CustomTooltip>
          <Button
            sx={{ m: 2 }}
            component="label"
            variant="contained"
            onClick={openManualUploadSubmittedInvoiceModal}
          >
            Upload Manual Invoice
          </Button>
          <Button
            sx={{ color: "primary.main" }}
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setSubmittedInvoicesToDelete(selectedInvoices);
              setShowSubmittedConfirmDelete(true);
            }}
            disabled={selectedInvoices.length === 0}
          >
            <Delete />
          </Button>
        </Box>
      );
    }) as any,
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {submittedInvoiceListData?.data.totalElements ?? 0}
        </Typography>
      );
    },
  });

  // store grid configuration
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    enableRowSelection: true,
    enableRowActions: true,
    columns: columns,
    data: clientInvoiceListData?.data.content ?? [],
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount: clientInvoiceListData?.data.totalElements,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {},
      sorting: [
        {
          id: "invoiceGenerationDate",
          desc: true,
        },
      ],
    },
    state: {
      pagination,
      rowSelection,
      showProgressBars: isLoading,
      columnOrder: [
        "mrt-row-select",
        "mrt-row-actions",
        ...columns.map((col) => col.accessorKey!),
      ],
    },
    getRowId: (row) => `${row.clientInvoiceId}`,
    onRowSelectionChange: setRowSelection,
    renderRowActions: ({ row, table }) => {
      return (
        <Box>
          <IconButton
            title="Edit / View"
            color="info"
            onClick={(e) => {
              setCurrentInvoice(row.original);
              openInvoicePreviewModal();
            }}
          >
            <VisibilityIcon />
          </IconButton>
          <IconButton
            title="Download"
            disabled={
              !row.original.invoiceFilePath ||
              row.original.invoiceFilePath === ""
            }
            color={"primary"}
            onClick={() =>
              fetchClientInvoiceFile(
                row.original.id,
                row.original.invoiceStatus
              )
            }
          >
            <CloudDownloadIcon />
          </IconButton>
          <Button
            key={row.original.id}
            sx={{ m: 2 }}
            component="label"
            variant="contained"
            disabled={
              row.original.invoiceStatus !== CLIENT_INVOICE_STATUS.FIN_APPROVED
            }
            onClick={() => {
              setCurrentInvoice(row.original);
              openSubmitInvoiceModal();
            }}
          >
            Submit
          </Button>
        </Box>
      );
    },
    muiTableBodyRowProps: () => ({
      ...defaultMRTOptions.muiTableBodyRowProps,
    }),
    renderTopToolbarCustomActions: ({ table }) =>
      renderTopToolbarCustomActions(table),
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {clientInvoiceListData?.data.totalElements}
        </Typography>
      );
    },
  });

  // open  modal logic  incase user selects any of the store
  const [manualGenerateInvoiceModal, openManualGenerateInvoiceModal] =
    useSubmitModal((closeManualGenerateInvoiceModal) => (
      <ManualGenerateClientInvoiceModal
        clientId={clientId}
        clientType={props.clientType}
        closeManualGenerateClientInvoiceModal={() => {
          closeManualGenerateInvoiceModal();
        }}
        onCompleted={() => {
          closeManualGenerateInvoiceModal();
          getClientInvoiceListData();
        }}
      />
    ));

  // open manual upload submitted invoice modal logic
  const [manualUploadSubmittedInvoiceModal, openManualUploadSubmittedInvoiceModal] =
    useSubmitModal((closeManualUploadSubmittedInvoiceModal) => (
      <ManualUploadSubmittedInvoiceModal
        clientId={clientId}
        closeManualUploadSubmittedInvoiceModal={() => {
          closeManualUploadSubmittedInvoiceModal();
        }}
        onCompleted={() => {
          closeManualUploadSubmittedInvoiceModal();
          getSubmittedInvoiceListData();
        }}
      />
    ));

  interface InvoiceTabsViewProps {
    clientName: string;
    table: MRT_TableInstance<RatecardClientInvoiceResponse>;
    submittedTable: MRT_TableInstance<SubmittedClientInvoice>;
  }

  interface Invoice {
    id: number;
    fdpName: string;
    invoiceNumber: string;
    invoiceGenerationDate: string;
    invoicePeriod: string;
    invoiceStatus: string;
    paymentStatus: string;
    paidDate: string | null;
    proofOfPayment: string | null;
    currentStatus: InvoiceStatus;
    totalNetPayment: number;
  }

  const InvoiceTabsView: React.FC<InvoiceTabsViewProps> = ({
    clientName,
    table,
    submittedTable,
  }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [invoices, setInvoices] = useState<Invoice[]>([]);

    const [generatedInvoiceCounts, setGeneratedInvoiceCounts] = useState<{
      [key: string]: number;
    }>({});
    const [showFdpInvoiceEditModal, setShowFdpInvoiceEditModal] =
      useState(false);

    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

    const tabValueRef = React.useRef(tabValue);
    const [numberOfElements, setNumberOfElements] = useState(0);

    // Update the ref when tabValue changes
    useEffect(() => {
      tabValueRef.current = tabValue;
    }, [tabValue]);

    const extractClientDataFromFdpInvoices = (
      fdpInvoices: RatecardFdpInvoiceResponse[]
    ): ClientData[] => {
      let duplicateClientData: ClientData[] = [];

      fdpInvoices.forEach((fdpInvoice) => {
        if (fdpInvoice.stores && Array.isArray(fdpInvoice.stores)) {
          let clientsData: ClientData[] = fdpInvoice.stores.map((store) => ({
            clientId: store.clientId,
            clientName: store.clientName,
          }));
          duplicateClientData = duplicateClientData.concat(clientsData);
        }
      });

      let clientIdList: number[] = [];
      let uniqueClientData: ClientData[] = [];

      duplicateClientData.forEach((value) => {
        if (!clientIdList.includes(value.clientId)) {
          clientIdList.push(value.clientId);
          uniqueClientData.push(value);
        }
      });

      return uniqueClientData;
    };

    const isFdp = useSelector(
      (state: RootState) => state.login?.authResponse?.isFdp
    );
    const [currentFdpInvoice, setCurrentFdpInvoice] = useState<
      RatecardFdpInvoiceResponse | undefined
    >(undefined);

    const isFdc = useSelector(
      (state: RootState) => state.login?.authResponse?.isFdc
    );

    const VisuallyHiddenInput = styled("input")({
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: 1,
      overflow: "hidden",
      position: "absolute",
      bottom: 0,
      left: 0,
      whiteSpace: "nowrap",
      width: 1,
    });

    const [fdpInvoicePreviewModal, openFdpInvoicePreviewModal] = useSubmitModal(
      (closeInvoicePreviewModal) => (
        <FdpInvoicePreviewModal
          isView={false}
          invoice={currentFdpInvoice}
          closeInvoicePreviewModal={() => {
            closeInvoicePreviewModal();
            if (currentFdpInvoice?.fdpId !== undefined) {
              fetchInvoicesForFdp(currentFdpInvoice.fdpId);
            }
          }}
          showInvoiceEditModal={() => {
            closeInvoicePreviewModal();
            setShowFdpInvoiceEditModal(true);
          }}
        />
      )
    );

    // Store the raw response data for lookup later
    const [rawResponseData, setRawResponseData] = useState<
      RatecardFdpInvoiceResponse[]
    >([]);

    const dispatch = useAppDispatch();

    useEffect(() => {
      dispatch(getFdpListByClient(clientId));
    }, [dispatch]);

    // Get FDP data from Redux store
    const fdps = useSelector((state: RootState) => state.fdp.fdpListByClient);
    const fdpList = fdps.map((fdp) => fdp.companyName);
    const { selectedFDP } = useSelector((state: RootState) => state.fdp);
    const [fdpPagination, setFdpPagination] = useState<MRT_PaginationState>({
      pageIndex: 0,
      pageSize: 10,
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
      tabValueRef.current = newValue;
    };

    const [isRefreshing, setIsRefreshing] = useState(false);
    const fetchInvoicesForFdp = useCallback(
      async (fdpId: number) => {
        if (isRefreshing) return;

        try {
          setIsRefreshing(true);
          setIsLoading(true);
          const response = await FdpInvoiceAgent.getFdpInvoiceList(fdpId, {
            pageIndex: fdpPagination.pageIndex,
            pageSize: fdpPagination.pageSize,
          });

          if (!response.isSuccess) {
            toast.error(response.message!, {
              toastId: "fdpInvoiceList",
            });
            setInvoices([]);
            setRawResponseData([]);
            setGeneratedInvoiceCounts({});
            setClientData([]);
          } else {
            const content = response.data.content.filter(
              (fdpItem) => fdpItem.stores[0].clientId === clientId
            );
            setNumberOfElements(response.data.totalElements);
            setRawResponseData(content);

            const generatedCount = content.filter(
              (item) => item.currentStatus?.internalStatus === "fin_in_review"
            ).length;

            setGeneratedInvoiceCounts((prev) => ({
              ...prev,
              [selectedFDP || ""]: generatedCount,
            }));

            const transformedInvoices: Invoice[] = content.map((item) => ({
              id: item.id,
              fdpName: selectedFDP || "",
              invoiceNumber: item.fdpInvoiceId || "",
              invoiceGenerationDate: item.invoiceDate || "",
              invoicePeriod: item.invoicePeriod,
              invoiceStatus: item.currentStatus?.internalStatus || "",
              paymentStatus: item.invoiceStatus === "paid" ? "Paid" : "Pending",
              paidDate: item.receiptUploadedOn || null,
              proofOfPayment: item.receiptFile ? item.receiptName : null,
              currentStatus: item.currentStatus,
              totalNetPayment: item.totalNetPayment,
            }));

            setInvoices(transformedInvoices);
          }
        } catch (error) {
          const appError = getAxiosError(error);
          toast.error(appError.errorMessage, {
            toastId: "fdpInvoiceListException",
          });
          setInvoices([]);
          setRawResponseData([]);
          setGeneratedInvoiceCounts({});
          setClientData([]);
        } finally {
          setIsLoading(false);
          setIsRefreshing(false);
        }
      },
      [selectedFDP, isFdpInvoice, fdpPagination.pageIndex, fdpPagination.pageSize]
    );

    // Update the useEffect to only trigger on selectedFDP change
    useEffect(() => {
      let isMounted = true;
      if (selectedFDP && !isRefreshing && isMounted) {
        const selectedFdpData = fdps.find(
          (fdp) => fdp.companyName === selectedFDP
        );
        if (selectedFdpData) {
          fetchInvoicesForFdp(selectedFdpData.id);
        }
      }
      return () => {
        isMounted = false;
      };
    }, [selectedFDP, fdps, fetchInvoicesForFdp]);

    // Updated columns configuration
    const columns: MRT_ColumnDef<Invoice>[] = [
      {
        accessorKey: "actions",
        header: "Actions",
        size: 150,
        Cell: ({ row, table }) => {
          return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <IconButton
                  color="info"
                  onClick={(e) => {
                    const currentInvoice = row.original;
                    const fdpInvoice = rawResponseData.find(
                      (item) =>
                        item.id === currentInvoice.id &&
                        item.invoiceStatus === currentInvoice.invoiceStatus
                    );

                    if (fdpInvoice) {
                      setCurrentFdpInvoice(fdpInvoice);
                      openFdpInvoicePreviewModal();
                    } else {
                      toast.error("Invoice details not found");
                    }
                  }}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  onClick={() => handleDownload(row.original)}
                >
                  <CloudDownloadIcon />
                </IconButton>
              </Box>
            </Box>
          );
        },
      },
      {
        accessorKey: "invoiceStatus",
        header: "Invoice Status",
        size: 100,
        Cell: ({ row }) => {
          const theme = useTheme();
          // Get background color based on the invoice status
          const bgColor = getInvoiceStatusCellColour(
            row?.original?.invoiceStatus,
            theme
          );
          return (
            <Box
              sx={{
                color: bgColor !== "white" ? "white" : "black",
                backgroundColor: bgColor,
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              {isFdc
                ? row?.original?.currentStatus?.fdcExternalStatus
                : isFdp
                  ? row?.original?.currentStatus?.fdpExternalStatus
                  : ""}
            </Box>
          );
        },
      },
      {
        accessorKey: "fdpName",
        header: "FDP Name",
      },
      {
        accessorKey: "invoiceNumber",
        header: "Invoice Number",
      },
      {
        accessorKey: "totalNetPayment",
        header: "Net Payment ($)",
      },
      {
        accessorKey: "invoiceGenerationDate",
        header: "Invoice Generation Date",
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatISODateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: "invoicePeriod",
        header: "Invoice Period",
        Cell: ({ cell }) => {
          const value = cell.getValue<string>();
          if (!value) return "N/A";
          const formattedDate = formatFromAndToDateString(value);
          return formattedDate;
        },
      },
      {
        accessorKey: "paymentStatus",
        header: "Payment Status",
      },
      //Commented Paid Date & proofOfPayment as per https://fdc-org.atlassian.net/browse/FDC-79
      // {
      //   accessorKey: "paidDate",
      //   header: "Paid Date",
      //   Cell: ({ cell }): React.ReactNode => {
      //     const value = cell.getValue<string | null>();
      //     return value ? new Date(value).toLocaleDateString() : "N/A";
      //   },
      // },
      // {
      //   accessorKey: "proofOfPayment",
      //   header: "Proof of Payment",
      //   size: 100,
      //   Cell: ({ cell, row }) => {
      //     const { paidDate, invoiceStatus, proofOfPayment, id } = row?.original;

      //     // Handle file download
      //     const handleDownload = () => {
      //       if (proofOfPayment) {
      //         // Find the raw data corresponding to this row
      //         const rawData = rawResponseData.find((item) => item.id === id);
      //         if (rawData?.receiptFile) {
      //           // Step 1: Create a Blob from the Base64 string
      //           const byteCharacters = atob(rawData.receiptFile);
      //           const byteArrays = [];
      //           for (
      //             let offset = 0;
      //             offset < byteCharacters.length;
      //             offset += 1024
      //           ) {
      //             const slice = byteCharacters.slice(
      //               offset,
      //               Math.min(offset + 1024, byteCharacters.length)
      //             );
      //             const byteNumbers = new Array(slice.length);
      //             for (let i = 0; i < slice.length; i++) {
      //               byteNumbers[i] = slice.charCodeAt(i);
      //             }
      //             byteArrays.push(new Uint8Array(byteNumbers));
      //           }
      //           const blob = new Blob(byteArrays, {
      //             type: "application/octet-stream",
      //           });
      //           const url = URL.createObjectURL(blob);
      //           const link = document.createElement("a");
      //           link.href = url;
      //           link.download = rawData.receiptName || "proof_of_payment";
      //           document.body.appendChild(link);
      //           link.click();
      //           document.body.removeChild(link);
      //           URL.revokeObjectURL(url);
      //         }
      //       }
      //     };

      //     const paymentProofUploaded = paidDate ? true : false;

      //     // Handle file upload
      //     const handleFileChange = async (event: any) => {
      //       const file = event.target.files[0];
      //       const formData = new FormData();
      //       if (file) {
      //         formData.append("file", file);
      //       }
      //       try {
      //         const response = await FdpInvoiceAgent.saveFdpReceiptFile(
      //           id,
      //           formData
      //         );
      //         if (response.includes("Receipt Uploaded Successfully")) {
      //           toast.success("Receipt Uploaded Successfully", {
      //             toastId: "receiptUploadSuccess",
      //           });

      //           // Get the selected FDP data and refresh the invoice list
      //           const selectedFdpData = fdps.find(
      //             (fdp) => fdp.companyName === selectedFDP
      //           );
      //           if (selectedFdpData) {
      //             fetchInvoicesForFdp(selectedFdpData.id);
      //           }
      //         }
      //       } catch (error) {
      //         const appError = getAxiosError(error);
      //         toast.error("Error uploading Receipt.", {
      //           toastId: "receiptUploadException",
      //         });
      //       }
      //     };

      //     // If payment proof is uploaded, show download button
      //     if (paymentProofUploaded) {
      //       return (
      //         <IconButton
      //           title="Download"
      //           color={"primary"}
      //           onClick={handleDownload}
      //         >
      //           <CloudDownloadIcon />
      //         </IconButton>
      //       );
      //     }

      //     // If status allows uploading and not yet uploaded
      //     if (
      //       invoiceStatus === "fdp_accepted" &&
      //       paymentProofUploaded === false &&
      //       isFdc
      //     ) {
      //       return (
      //         <Button
      //           component="label"
      //           role={undefined}
      //           variant="contained"
      //           tabIndex={-1}
      //           startIcon={<CloudUploadIcon />}
      //         >
      //           Upload Receipt
      //           <VisuallyHiddenInput
      //             type="file"
      //             onChange={handleFileChange}
      //             multiple
      //           />
      //         </Button>
      //       );
      //     }

      //     // Default fallback
      //     return <span>No receipt uploaded</span>;
      //   },
      // },
    ];

    // Action Handlers
    const handleViewPDF = (invoice: Invoice) => {
      console.log("Viewing PDF for invoice:", invoice);
      // Implement PDF viewing logic
      // You might want to use FdpInvoiceAgent.fetchFdpInvoiceFile from the second document
    };

    const handleDownload = (invoice: Invoice) => {
      console.log("Downloading invoice:", invoice);
      // Use the fetchFdpInvoiceFile function from FdpInvoiceAgent as shown in second document
      if (invoice.id) {
        try {
          setIsLoading(true);
          FdpInvoiceAgent.fetchFdpInvoiceFileCsv(invoice.id, invoice.invoiceStatus)
            .then((response) => {
              if (response.status !== 200) {
                toast.error("Document couldn't be retrieved.", {
                  toastId: "FetchInvoiceFileError",
                });
                return;
              }

              const fileName =
                response.headers["file-name"] ||
                `invoice-${invoice.invoiceNumber}.xlsx`;
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch((error) => {
              const appError = getAxiosError(error);
              toast.error("File isn't accessible.", {
                toastId: "FetchInvoiceFileException",
              });
            })
            .finally(() => {
              setIsLoading(false);
            });
        } catch (error) {
          setIsLoading(false);
          toast.error("An error occurred during download", {
            toastId: "downloadError",
          });
        }
      }
    };

    // Helper function to refresh data
    const refreshData = useCallback(() => {
      //setIsFdpInvoice(false);
      if (selectedFDP) {
        const selectedFdpData = fdps.find(
          (fdp) => fdp.companyName === selectedFDP
        );
        if (selectedFdpData) {
          fetchInvoicesForFdp(selectedFdpData.id);
        }
      }
    }, [selectedFDP, fdps, fetchInvoicesForFdp]);

    const handleOpenFdpEditModal = () => {
      setShowFdpInvoiceEditModal(true);
    };

    const [showFdpConfirmDelete, setShowFdpConfirmDelete] = useState(false);
    const [fdpInvoiceData, setFdpInvoiceData] = useState({
      clientInvoiceIds: [] as string[],
      source: "fdp",
    });

    const handleFdpConfirmSoftDelete = (clientInvoiceIds: string[]) => {
      setFdpInvoiceData({ clientInvoiceIds, source: "fdp" });
      setShowFdpConfirmDelete(true);
    };

    const handleFdpInvoiceSoftDelete = async () => {
      setIsLoading(true);
      setShowFdpConfirmDelete(false);
      try {
        const { clientInvoiceIds } = fdpInvoiceData;
        const response = await ClientInvoiceAgent.softDeleteInvoices(
          clientInvoiceIds,
          "fdp"
        );

        if (selectedFDP) {
          const selectedFdpData = fdps.find(
            (fdp) => fdp.companyName === selectedFDP
          );
          if (selectedFdpData) {
            setIsRefreshing(false);
            setIsFdpInvoice(true);
            await fetchInvoicesForFdp(selectedFdpData.id);
          }
        }

        return true;
      } catch (error) {
        const appError = getAxiosError(error);
        console.error("Error during FDP invoice soft delete:", appError);
        toast.error(appError.errorMessage, {
          toastId: "fdpInvoiceSoftDeleteException",
        });
        return false;
      } finally {
        setIsLoading(false);
        setFdpInvoiceData({ clientInvoiceIds: [], source: "" });
      }
    };

    // Update the useEffect to handle refresh when isFdpInvoice changes
    useEffect(() => {
      if (isFdpInvoice && selectedFDP) {
        const selectedFdpData = fdps.find(
          (fdp) => fdp.companyName === selectedFDP
        );
        if (selectedFdpData) {
          fetchInvoicesForFdp(selectedFdpData.id);
        }
        setIsFdpInvoice(false);
      }
    }, [isFdpInvoice, selectedFDP, fdps, fetchInvoicesForFdp]);

    const renderTopToolbarCustomActions = ({
      table,
    }: {
      table: MRT_TableInstance<Invoice>;
    }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const selectedInvoiceIds = selectedRows.map(
        (row: { original: Invoice }) => row.original.invoiceNumber
      );

      const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        handleFdpConfirmSoftDelete(selectedInvoiceIds);
      };

      const handleRefresh = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        refreshData();
      };

      return (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <CustomTooltip arrow title="Refresh" onClick={handleRefresh}>
            <IconButton>
              <CachedIcon sx={{ color: "primary.main" }} />
            </IconButton>
          </CustomTooltip>
          <Button
            sx={{ color: "primary.main" }}
            color="error"
            onClick={handleDelete}
            disabled={selectedInvoiceIds.length === 0}
          >
            <Delete />
          </Button>
        </Box>
      );
    };

    return (
      <>
        {showFdpInvoiceEditModal ? (
          <FdpInvoiceEditModal
            fdpId={currentFdpInvoice?.fdpId || 0}
            fdpInvoice={currentFdpInvoice}
            closeInvoiceEditModal={() => {
              setShowFdpInvoiceEditModal(false);

              // refresh invoice list after edit
              setIsLoading(true);
              if (currentFdpInvoice?.fdpId !== undefined) {
                fetchInvoicesForFdp(currentFdpInvoice.fdpId);
              }
            }}
            onAddMoreStores={() => {
              setShowFdpInvoiceEditModal(false);

              setTimeout(function () {
                // delay for 0.5 seconds so that the invoice is closed and it can be re-opened without any issues and with a state that is reset
                setShowFdpInvoiceEditModal(true);
              }, 500);
            }}
            clients={extractClientDataFromFdpInvoices(rawResponseData)} // Pass the client data
          />
        ) : null}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Client-Invoices" />
            <Tab label="FDP-Invoices" />
            <Tab label="Submitted to Client" />
          </Tabs>
        </Box>
        <ConfirmModal
          open={showFdpConfirmDelete}
          onClose={() => {
            setShowFdpConfirmDelete(false);
          }}
          asyncOperation={handleFdpInvoiceSoftDelete}
          closeModalAfterSubmit={true}
          closeSubmitModal={() => {
            setShowFdpConfirmDelete(false);
          }}
          confirmMessage={
            "This action will delete the invoice. Are you sure you want to proceed?"
          }
        />

        {tabValue === 0 ? (
          <Grid item xs={12} marginTop={2}>
            <MaterialReactTable table={table} />
          </Grid>
        ) : tabValue === 2 ? (
          <Grid item xs={12} marginTop={2}>
            <MaterialReactTable table={submittedTable} />
          </Grid>
        ) : (
          <>
            {fdpList.map((fdp, index) => (
              <Accordion
                sx={{
                  borderRadius: 2,
                  boxShadow: 3,
                  borderBottom: 2,
                  borderColor: "#2e7d32",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandCircleDown />}
                  aria-controls="panel1-content"
                  id={`${fdp}`}
                  onClick={() => dispatch(setSelectedFDP(fdp))}
                  sx={{
                    marginBlock: 2,
                    backgroundColor:
                      selectedFDP === fdp ? "#dbdbdb" : "#f5f5f5",
                  }}
                >
                  {fdp}
                  {selectedFDP === fdp && generatedInvoiceCounts[fdp] > 0 ? (
                    <>
                      <FlagIcon
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: 1 }}
                      />
                      <Typography
                        variant="caption"
                        color="error"
                        sx={{ marginLeft: 0.5 }}
                      >
                        {generatedInvoiceCounts[fdp]}
                      </Typography>
                    </>
                  ) : null}
                </AccordionSummary>
                <AccordionDetails>
                  {selectedFDP === fdp && (
                    <>
                      {fdpInvoicePreviewModal}
                      <MaterialReactTable
                        columns={columns}
                        data={invoices}
                        enableRowSelection={true}
                        rowCount={numberOfElements}
                        manualPagination={true}
                        paginationDisplayMode="pages"
                        muiTableHeadCellProps={{
                          sx: {
                            backgroundColor: "#f5f5f5",
                            fontWeight: "bold",
                          },
                        }}
                        muiTableContainerProps={{
                          sx: {
                            maxHeight: "450px",
                            overflowY: "auto",
                          },
                        }}
                        initialState={{
                          sorting: [
                            {
                              id: "invoiceGenerationDate",
                              desc: true,
                            },
                          ],
                        }}
                        state={{
                          showProgressBars: isLoading,
                          pagination: { pageIndex: fdpPagination.pageIndex, pageSize: fdpPagination.pageSize },
                          rowSelection,
                        }}
                        onRowSelectionChange={setRowSelection}
                        onPaginationChange={setFdpPagination}
                        renderTopToolbarCustomActions={
                          renderTopToolbarCustomActions
                        }
                      />
                    </>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </>
        )}
      </>
    );
  };

  return (
    <>
      <InvoiceTabsView clientName={clientName} table={table} submittedTable={submittedTable} />

      {manualGenerateInvoiceModal}
      {manualUploadSubmittedInvoiceModal}
      {invoicePreviewModal}
      {submittedInvoicePreviewModal}
      {submitInvoiceModal}
      <ConfirmModal
        open={showSubmittedConfirmDelete}
        onClose={() => setShowSubmittedConfirmDelete(false)}
        asyncOperation={handleSubmittedInvoiceSoftDelete}
        closeModalAfterSubmit={true}
        closeSubmitModal={() => setShowSubmittedConfirmDelete(false)}
        confirmMessage={"This action will delete the submitted invoice. Are you sure you want to proceed?"}
      />
      {showInvoiceEditModal ? (
        <InvoiceEditModal
          clientId={clientId}
          invoice={currentInvoice}
          closeInvoiceEditModal={() => {
            setShowInvoiceEditModal(false);
            setIsLoading(true);
            getClientInvoiceListData();
          }}
          onAddMoreStores={() => {
            setShowInvoiceEditModal(false);
            setTimeout(function () {
              setShowInvoiceEditModal(true);
            }, 500);
          }}
        />
      ) : null}
      <ConfirmModal
        open={showConfirmDelete}
        onClose={() => {
          setShowConfirmDelete(false);
        }}
        asyncOperation={handleInvoiceSoftDelete}
        closeModalAfterSubmit={true}
        closeSubmitModal={() => {
          setShowConfirmDelete(false);
        }}
        confirmMessage={
          "This action will delete the invoice. Are you sure you want to proceed?"
        }
      />
    </>
  );
};
export default ClientInvoiceList;
